import PropTypes from 'prop-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
(function () {
  if (typeof document === "undefined") {
    return;
  }
  const styles = ".kof-dropdown {\n  border: 1px solid #767676;\n  border-radius: 2px;\n  padding: 5px;\n  height: 32px;\n  background: white;\n}";
  const fileName = "Dropdown_Dropdown_9de4e75c-7082-44ab-876e-63efe89bc3eb";
  const element = document.querySelector("style[data-sass-component='Dropdown_Dropdown_9de4e75c-7082-44ab-876e-63efe89bc3eb']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
function Dropdown({
  options,
  optionsGroups,
  value,
  onChange,
  id,
  disabled,
  placeholder,
  withEmptyOption = true
}) {
  value = value === null ? '' : value;
  const renderOptions = options => options.map(item => {
    return /*#__PURE__*/_jsx("option", {
      value: item.value,
      children: item.label
    }, item.value);
  });
  const renderOptionsGroups = () => optionsGroups.map(optionsGroup => {
    return /*#__PURE__*/_jsx("optgroup", {
      label: optionsGroup.label,
      children: renderOptions(optionsGroup.options)
    }, optionsGroup.label);
  });
  const renderProvidedOptions = () => {
    if (options) {
      return renderOptions(options);
    }
    if (optionsGroups) {
      return renderOptionsGroups();
    }
  };
  return /*#__PURE__*/_jsxs("select", {
    className: 'kof-dropdown',
    value: value,
    onChange: event => onChange(event.target.value),
    disabled: disabled,
    id: id,
    children: [placeholder && /*#__PURE__*/_jsx("option", {
      value: '',
      hidden: true,
      children: placeholder
    }), withEmptyOption && /*#__PURE__*/_jsx("option", {}), renderProvidedOptions()]
  });
}
const optionsPropTypes = PropTypes.arrayOf(PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
}));
Dropdown.propTypes = {
  options: optionsPropTypes,
  optionsGroups: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    options: optionsPropTypes
  })),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  withEmptyOption: PropTypes.bool
};
export { Dropdown };